// import React, { useState, useEffect, MouseEvent } from "react";
// import "./ProductCard.css";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import { teal } from "@mui/material/colors";
// import { Box, Button, IconButton, Modal } from "@mui/material";
// import { useNavigate, useParams } from "react-router-dom";
// import { Product } from "../../../../types/productTypes";
// import {
//     useAppDispatch,
//     useAppSelector,
// } from "../../../../Redux Toolkit/Store";
// import { fetchProductById } from "../../../../Redux Toolkit/Customer/ProductSlice";
// import { addProductToWishlist } from "../../../../Redux Toolkit/Customer/WishlistSlice";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import { isWishlisted } from "../../../../util/isWishlisted";
// import ModeCommentIcon from '@mui/icons-material/ModeComment';
// import ChatBot from "../../ChatBot/ChatBot";

// interface ProductCardProps {
//     // images: string[];
//     // categoryId: string | undefined;
//     item: Product;
// }
// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: "auto",
//     borderRadius: ".5rem",
//     boxShadow: 24,

// };

// const ProductCard: React.FC<ProductCardProps> = ({ item }) => {
//     const [currentImage, setCurrentImage] = useState(0);
//     const [isHovered, setIsHovered] = useState(false);
//     const [isFavorite, setIsFavorite] = useState(false);
//     const { wishlist } = useAppSelector((store) => store);
//     const navigate = useNavigate();
//     const dispatch = useAppDispatch();
//     const [showChatBot, setShowChatBot] = useState(false)

//     const handleAddWishlist = (event: MouseEvent) => {
//         event.stopPropagation();
//         setIsFavorite((prev) => !prev);
//         if (item.id) dispatch(addProductToWishlist({ productId: item.id }));
//     };

//     useEffect(() => {
//         let interval: any;
//         if (isHovered) {
//             interval = setInterval(() => {
//                 setCurrentImage((prevImage) => (prevImage + 1) % item.images.length);
//             }, 1000); // Change image every 1 second
//         } else if (interval) {
//             clearInterval(interval);
//         }
//         return () => clearInterval(interval);
//     }, [isHovered, item.images.length]);

//     const handleShowChatBot = (event: MouseEvent) => {
//         event.stopPropagation();
//         setShowChatBot(true)
//     }
//     const handleCloseChatBot = (e: MouseEvent) => {
//         e.stopPropagation();
//         setShowChatBot(false)
//     }

//     return (
//         <>
//             <div
//                 onClick={() =>
//                     navigate(
//                         `/product-details/${item.category?.categoryId}/${item.title}/${item.id}`
//                     )
//                 }
//                 className="group px-4 relative"
//             >
//                 <div
//                     className="card "
//                     onMouseEnter={() => setIsHovered(true)}
//                     onMouseLeave={() => setIsHovered(false)}
//                 >
//                     {item.images.map((image: any, index: number) => (
//                         <img
//                             key={index}
//                             className="card-media object-top"
//                             src={image}
//                             alt={`product-${index}`}
//                             style={{
//                                 transform: `translateX(${(index - currentImage) * 100}%)`,
//                             }}
//                         />
//                     ))}
//                     {isHovered && (
//                         <div className="indicator flex flex-col items-center space-y-2">
//                             <div className="flex gap-4">
//                                 {item.images.map((item: any, index: number) => (
//                                     <button
//                                         key={index}
//                                         className={`indicator-button ${index === currentImage ? "active" : ""
//                                             }`}
//                                         onClick={() => setCurrentImage(index)}
//                                     />
//                                 ))}
//                             </div>

//                             <div className="flex gap-3">
//                                 {wishlist.wishlist && (
//                                     <Button
//                                         variant="contained"
//                                         color="secondary"

//                                         sx={{ zIndex: 10 }}
//                                         className=" z-50"
//                                         onClick={handleAddWishlist}
//                                     >
//                                         {isWishlisted(wishlist.wishlist, item) ? (
//                                             <FavoriteIcon sx={{ color: teal[500] }} />
//                                         ) : (
//                                             <FavoriteBorderIcon sx={{ color: "gray" }} />
//                                         )}
//                                     </Button>
//                                 )}
//                                 {/* <Button onClick={handleShowChatBot} color="secondary" variant="contained">
//                                     <ModeCommentIcon sx={{ color: teal[500] }} />
//                                 </Button> */}
//                             </div>


//                         </div>
//                     )}
//                 </div>
//                 <div className="details pt-3 space-y-1 group-hover-effect  rounded-md ">
//                     <div className="name space-y ">
//                         <h1 className="font-semibold text-lg">
//                             {item.seller?.businessDetails.businessName}
//                         </h1>
//                         <p className="">{item.title}</p>
//                     </div>
//                     <div className="price flex items-center gap-3 ">
//                         <span className="font-semibold text-gray-800">
//                             {" "}
//                             ₹{item.sellingPrice}
//                         </span>
//                         <span className="text thin-line-through text-gray-400 ">
//                             ₹{item.mrpPrice}
//                         </span>
//                         <span className="text-[#00927c] font-semibold">
//                             {item.discountPercent}% off
//                         </span>
//                     </div>
//                 </div>

//             </div>
//             {showChatBot && <section className="absolute left-16 top-0">
//                 <Modal
//                     open={true}
//                     onClose={handleCloseChatBot}
//                     aria-labelledby="modal-modal-title"
//                     aria-describedby="modal-modal-description"
//                 >
//                     <Box sx={style}>
//                         <ChatBot handleClose={handleCloseChatBot} productId={item.id} />
//                     </Box>
//                 </Modal>

//             </section>}
//         </>
//     );
// };

// export default ProductCard;


import React, { useState, useEffect, MouseEvent } from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { teal } from "@mui/material/colors";
import { Box, Button, IconButton, Modal } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Product } from "../../../../types/productTypes";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../Redux Toolkit/Store";
import { fetchProductById } from "../../../../Redux Toolkit/Customer/ProductSlice";
import { addProductToWishlist } from "../../../../Redux Toolkit/Customer/WishlistSlice";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { isWishlisted } from "../../../../util/isWishlisted";
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import ChatBot from "../../ChatBot/ChatBot";

interface ProductCardProps {
  item: Product;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "auto",
  borderRadius: ".5rem",
  boxShadow: 24,
};

const ProductCard: React.FC<ProductCardProps> = ({ item }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const { wishlist } = useAppSelector((store) => store);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showChatBot, setShowChatBot] = useState(false);

  const handleAddWishlist = (event: MouseEvent) => {
    event.stopPropagation();
    setIsFavorite((prev) => !prev);
    if (item.id) dispatch(addProductToWishlist({ productId: item.id }));
  };

  useEffect(() => {
    let interval: any;
    if (isHovered && item.images?.length > 1) {
      interval = setInterval(() => {
        setCurrentImage((prevImage) => (prevImage + 1) % item.images.length);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isHovered, item.images.length]);

  const handleShowChatBot = (event: MouseEvent) => {
    event.stopPropagation();
    setShowChatBot(true);
  };

  const handleCloseChatBot = (e: MouseEvent) => {
    e.stopPropagation();
    setShowChatBot(false);
  };

  return (
    <>
      <div
        onClick={() =>
          navigate(
            `/product-details/${item.category?.categoryId}/${item.title}/${item.id}`
          )
        }
        className="group cursor-pointer overflow-hidden rounded-[16px] bg-white shadow-[0_10px_24px_rgba(2,6,23,0.12)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_30px_rgba(2,6,23,0.16)]"
      >
        {/* Image Area */}
        <div
          className="relative overflow-hidden"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="relative h-[150px] sm:h-[165px] md:h-[180px] lg:h-[195px] xl:h-[210px] w-full overflow-hidden bg-slate-100">
            {item.images.map((image: any, index: number) => (
              <img
                key={index}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                src={image}
                alt={`product-${index}`}
                style={{
                  transform: `translateX(${(index - currentImage) * 100}%)`,
                }}
              />
            ))}
          </div>

          {isHovered && (
            <div className="absolute inset-x-0 bottom-3 z-10 flex flex-col items-center space-y-2">
              <div className="flex gap-2">
                {item.images.map((item: any, index: number) => (
                  <button
                    key={index}
                    className={`h-2 rounded-full transition-all ${
                      index === currentImage ? "w-5 bg-white" : "w-2 bg-white/70"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImage(index);
                    }}
                  />
                ))}
              </div>

              <div className="flex gap-3">
                {wishlist.wishlist && (
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{ zIndex: 10, minWidth: "auto", px: 1.5 }}
                    className="z-50"
                    onClick={handleAddWishlist}
                  >
                    {isWishlisted(wishlist.wishlist, item) ? (
                      <FavoriteIcon sx={{ color: teal[500] }} />
                    ) : (
                      <FavoriteBorderIcon sx={{ color: "gray" }} />
                    )}
                  </Button>
                )}
                {/* <Button onClick={handleShowChatBot} color="secondary" variant="contained">
                  <ModeCommentIcon sx={{ color: teal[500] }} />
                </Button> */}
              </div>
            </div>
          )}
        </div>

        {/* Details Area - white, no bottom dark strip */}
        <div className="px-3 py-3 sm:px-4 sm:py-4 bg-white">
          <div className="space-y-1">
            <h1 className="line-clamp-1 text-sm sm:text-base lg:text-lg font-semibold text-slate-900">
              {item.seller?.businessDetails.businessName}
            </h1>
            <p className="line-clamp-2 min-h-[40px] text-xs sm:text-sm lg:text-[15px] text-slate-600 leading-5">
              {item.title}
            </p>
          </div>

          <div className="mt-2 flex items-end justify-between gap-2">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-semibold text-gray-800 text-sm sm:text-base">
                ₹{item.sellingPrice}
              </span>
              <span className="text-xs sm:text-sm line-through text-gray-400">
                ₹{item.mrpPrice}
              </span>
            </div>

            <span className="shrink-0 text-xs sm:text-sm font-bold text-[#00927c]">
              {item.discountPercent}% off
            </span>
          </div>
        </div>
      </div>

      {showChatBot && (
        <section className="absolute left-16 top-0">
          <Modal
            open={true}
            onClose={handleCloseChatBot}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <ChatBot handleClose={handleCloseChatBot} productId={item.id} />
            </Box>
          </Modal>
        </section>
      )}
    </>
  );
};

export default ProductCard;